import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

let toastContainer = null;

const Toast = ({ message, duration }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, duration);

    return () => {
      clearTimeout(timer);
    };
  }, [duration]);

  return (
    <div className={`toast ${visible ? 'visible' : ''}`}>
      {message}
    </div>
  );
};

const ToastService = {
  show: (message, duration) => {
    if (toastContainer) {
      toastContainer.innerHTML = '';
    }

    const div = document.createElement('div');
    toastContainer = div;
    document.body.appendChild(div);

    ReactDOM.render(<Toast message={message} duration={duration} />, div);
  },
};

export default ToastService;